
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.01 13.51"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Path 3563","d":"M4.79 8.92a4.45 4.45 0 0 1 2-1.11C6.22 7.66 6 7.47 6 7.23V7s.5-.32.58-1.56A1 1 0 0 0 7 4.93a1.91 1.91 0 0 0 .08-.54c0-.15-.17 0-.17 0a6 6 0 0 0 0-.74C7 3.16 6.74 2.1 5.83 2a2.61 2.61 0 0 0-2.66 0c-1 .7-.56 2.32-.56 2.32a.18.18 0 0 0-.23.11c0 .22.19.89.54 1A3.33 3.33 0 0 0 3.54 7v.2a.63.63 0 0 1-.39.5 2.79 2.79 0 0 1-.7.19 4 4 0 0 0-2.05.88 2.1 2.1 0 0 0-.4 1.58c0 .3.09.41.43.62a9.11 9.11 0 0 0 3.68.94c0-.11 0-.24-.06-.37a3.55 3.55 0 0 1 .74-2.62zm16.85-.13a3.76 3.76 0 0 0-2.06-.89c-.82-.17-1.1-.39-1.1-.65V7s.5-.32.59-1.56a1 1 0 0 0 .41-.44 1.91 1.91 0 0 0 .09-.54c0-.15-.18 0-.18 0a6 6 0 0 0 .05-.74c0-.45-.24-1.51-1.15-1.62a2.63 2.63 0 0 0-2.67 0c-1 .69-.56 2.32-.56 2.32a.18.18 0 0 0-.23.11c0 .22.2.89.54 1A3.32 3.32 0 0 0 16 7v.2a.65.65 0 0 1-.39.5l-.37.13a4.5 4.5 0 0 1 2 1.1 3.32 3.32 0 0 1 .67 2.6c0 .13 0 .26-.06.36a8.29 8.29 0 0 0 3.66-.89c.34-.19.41-.3.43-.62a1.71 1.71 0 0 0-.3-1.56zm-7.56-.57C13 8 12.63 7.7 12.63 7.36v-.28s.65-.44.78-2a1.2 1.2 0 0 0 .59-.73 2 2 0 0 0 .13-.72c0-.19-.24 0-.24 0a6.63 6.63 0 0 0 .07-1c0-.61-.33-2-1.52-2.12a3.37 3.37 0 0 0-3.48 0c-1.34.91-.74 3.06-.74 3.06a.21.21 0 0 0-.28.13.14.14 0 0 0 0 .06c0 .28.24 1.17.72 1.3a4.27 4.27 0 0 0 .82 2v.23a.87.87 0 0 1-.5.67 3.26 3.26 0 0 1-.98.26 5.21 5.21 0 0 0-2.71 1.17 2.66 2.66 0 0 0-.48 2.06c0 .41.11.54.59.82a12 12 0 0 0 5.65 1.24 12 12 0 0 0 5.65-1.24c.45-.26.54-.41.58-.82a2.71 2.71 0 0 0-.47-2.06 5.4 5.4 0 0 0-2.73-1.17z","fill":"#444"}})])])])
          )
        }
      }
    